/**
 * Fallback country data used when database fetch fails
 * This list is kept in sync with the database but serves as a backup
 */
export interface FallbackCountry {
  code: string;
  name_en: string;
  name_kr: string;
  continent: string;
}

export const fallbackCountries: FallbackCountry[] = [
  // Asia
  { code: 'AU', name_en: 'Australia', name_kr: '호주', continent: 'Oceania' },
  { code: 'BD', name_en: 'Bangladesh', name_kr: '방글라데시', continent: 'Asia' },
  { code: 'KH', name_en: 'Cambodia', name_kr: '캄보디아', continent: 'Asia' },
  { code: 'CN', name_en: 'China', name_kr: '중국', continent: 'Asia' },
  { code: 'HK', name_en: 'Hong Kong', name_kr: '홍콩', continent: 'Asia' },
  { code: 'IN', name_en: 'India', name_kr: '인도', continent: 'Asia' },
  { code: 'ID', name_en: 'Indonesia', name_kr: '인도네시아', continent: 'Asia' },
  { code: 'JP', name_en: 'Japan', name_kr: '일본', continent: 'Asia' },
  { code: 'KZ', name_en: 'Kazakhstan', name_kr: '카자흐스탄', continent: 'Central Asia' },
  { code: 'MY', name_en: 'Malaysia', name_kr: '말레이시아', continent: 'Asia' },
  { code: 'MN', name_en: 'Mongolia', name_kr: '몽골', continent: 'Asia' },
  { code: 'MM', name_en: 'Myanmar', name_kr: '미얀마', continent: 'Asia' },
  { code: 'NP', name_en: 'Nepal', name_kr: '네팔', continent: 'Asia' },
  { code: 'NZ', name_en: 'New Zealand', name_kr: '뉴질랜드', continent: 'Oceania' },
  { code: 'PK', name_en: 'Pakistan', name_kr: '파키스탄', continent: 'Asia' },
  { code: 'PH', name_en: 'Philippines', name_kr: '필리핀', continent: 'Asia' },
  { code: 'SG', name_en: 'Singapore', name_kr: '싱가포르', continent: 'Asia' },
  { code: 'KR', name_en: 'South Korea', name_kr: '대한민국', continent: 'Asia' },
  { code: 'LK', name_en: 'Sri Lanka', name_kr: '스리랑카', continent: 'Asia' },
  { code: 'TW', name_en: 'Taiwan', name_kr: '대만', continent: 'Asia' },
  { code: 'TH', name_en: 'Thailand', name_kr: '태국', continent: 'Asia' },
  { code: 'VN', name_en: 'Vietnam', name_kr: '베트남', continent: 'Asia' },

  // Europe
  { code: 'AT', name_en: 'Austria', name_kr: '오스트리아', continent: 'Europe' },
  { code: 'AZ', name_en: 'Azerbaijan', name_kr: '아제르바이잔', continent: 'Central Asia' },
  { code: 'BE', name_en: 'Belgium', name_kr: '벨기에', continent: 'Europe' },
  { code: 'BG', name_en: 'Bulgaria', name_kr: '불가리아', continent: 'Europe' },
  { code: 'HR', name_en: 'Croatia', name_kr: '크로아티아', continent: 'Europe' },
  { code: 'CZ', name_en: 'Czech Republic', name_kr: '체코', continent: 'Europe' },
  { code: 'DK', name_en: 'Denmark', name_kr: '덴마크', continent: 'Europe' },
  { code: 'EE', name_en: 'Estonia', name_kr: '에스토니아', continent: 'Europe' },
  { code: 'FI', name_en: 'Finland', name_kr: '핀란드', continent: 'Europe' },
  { code: 'FR', name_en: 'France', name_kr: '프랑스', continent: 'Europe' },
  { code: 'DE', name_en: 'Germany', name_kr: '독일', continent: 'Europe' },
  { code: 'GE', name_en: 'Georgia', name_kr: '조지아', continent: 'Central Asia' },
  { code: 'GR', name_en: 'Greece', name_kr: '그리스', continent: 'Europe' },
  { code: 'HU', name_en: 'Hungary', name_kr: '헝가리', continent: 'Europe' },
  { code: 'IE', name_en: 'Ireland', name_kr: '아일랜드', continent: 'Europe' },
  { code: 'IT', name_en: 'Italy', name_kr: '이탈리아', continent: 'Europe' },
  { code: 'XK', name_en: 'Kosovo', name_kr: '코소보', continent: 'Europe' },
  { code: 'LV', name_en: 'Latvia', name_kr: '라트비아', continent: 'Europe' },
  { code: 'LT', name_en: 'Lithuania', name_kr: '리투아니아', continent: 'Europe' },
  { code: 'LU', name_en: 'Luxembourg', name_kr: '룩셈부르크', continent: 'Europe' },
  { code: 'MT', name_en: 'Malta', name_kr: '몰타', continent: 'Europe' },
  { code: 'NL', name_en: 'Netherlands', name_kr: '네덜란드', continent: 'Europe' },
  { code: 'NO', name_en: 'Norway', name_kr: '노르웨이', continent: 'Europe' },
  { code: 'PL', name_en: 'Poland', name_kr: '폴란드', continent: 'Europe' },
  { code: 'PT', name_en: 'Portugal', name_kr: '포르투갈', continent: 'Europe' },
  { code: 'RO', name_en: 'Romania', name_kr: '루마니아', continent: 'Europe' },
  { code: 'RU', name_en: 'Russia', name_kr: '러시아', continent: 'Europe' },
  { code: 'RS', name_en: 'Serbia', name_kr: '세르비아', continent: 'Europe' },
  { code: 'SK', name_en: 'Slovakia', name_kr: '슬로바키아', continent: 'Europe' },
  { code: 'SI', name_en: 'Slovenia', name_kr: '슬로베니아', continent: 'Europe' },
  { code: 'ES', name_en: 'Spain', name_kr: '스페인', continent: 'Europe' },
  { code: 'SE', name_en: 'Sweden', name_kr: '스웨덴', continent: 'Europe' },
  { code: 'CH', name_en: 'Switzerland', name_kr: '스위스', continent: 'Europe' },
  { code: 'TR', name_en: 'Turkey', name_kr: '터키', continent: 'Middle East' },
  { code: 'UA', name_en: 'Ukraine', name_kr: '우크라이나', continent: 'Europe' },
  { code: 'GB', name_en: 'United Kingdom', name_kr: '영국', continent: 'Europe' },

  // Americas
  { code: 'AR', name_en: 'Argentina', name_kr: '아르헨티나', continent: 'South America' },
  { code: 'BR', name_en: 'Brazil', name_kr: '브라질', continent: 'South America' },
  { code: 'CA', name_en: 'Canada', name_kr: '캐나다', continent: 'North America' },
  { code: 'CL', name_en: 'Chile', name_kr: '칠레', continent: 'South America' },
  { code: 'CO', name_en: 'Colombia', name_kr: '콜롬비아', continent: 'South America' },
  { code: 'CR', name_en: 'Costa Rica', name_kr: '코스타리카', continent: 'North America' },
  { code: 'DO', name_en: 'Dominican Republic', name_kr: '도미니카 공화국', continent: 'North America' },
  { code: 'EC', name_en: 'Ecuador', name_kr: '에콰도르', continent: 'South America' },
  { code: 'SV', name_en: 'El Salvador', name_kr: '엘살바도르', continent: 'North America' },
  { code: 'GT', name_en: 'Guatemala', name_kr: '과테말라', continent: 'North America' },
  { code: 'JM', name_en: 'Jamaica', name_kr: '자메이카', continent: 'North America' },
  { code: 'MX', name_en: 'Mexico', name_kr: '멕시코', continent: 'North America' },
  { code: 'PA', name_en: 'Panama', name_kr: '파나마', continent: 'North America' },
  { code: 'PE', name_en: 'Peru', name_kr: '페루', continent: 'South America' },
  { code: 'PR', name_en: 'Puerto Rico', name_kr: '푸에르토리코', continent: 'North America' },
  { code: 'UY', name_en: 'Uruguay', name_kr: '우루과이', continent: 'South America' },
  { code: 'US', name_en: 'United States', name_kr: '미국', continent: 'North America' },
  { code: 'VE', name_en: 'Venezuela', name_kr: '베네수엘라', continent: 'South America' },

  // Middle East & Africa
  { code: 'BH', name_en: 'Bahrain', name_kr: '바레인', continent: 'Middle East' },
  { code: 'EG', name_en: 'Egypt', name_kr: '이집트', continent: 'Africa' },
  { code: 'IR', name_en: 'Iran', name_kr: '이란', continent: 'Middle East' },
  { code: 'IQ', name_en: 'Iraq', name_kr: '이라크', continent: 'Middle East' },
  { code: 'IL', name_en: 'Israel', name_kr: '이스라엘', continent: 'Middle East' },
  { code: 'JO', name_en: 'Jordan', name_kr: '요르단', continent: 'Middle East' },
  { code: 'KE', name_en: 'Kenya', name_kr: '케냐', continent: 'Africa' },
  { code: 'KW', name_en: 'Kuwait', name_kr: '쿠웨이트', continent: 'Middle East' },
  { code: 'LB', name_en: 'Lebanon', name_kr: '레바논', continent: 'Middle East' },
  { code: 'LY', name_en: 'Libya', name_kr: '리비아', continent: 'Africa' },
  { code: 'MA', name_en: 'Morocco', name_kr: '모로코', continent: 'Africa' },
  { code: 'NG', name_en: 'Nigeria', name_kr: '나이지리아', continent: 'Africa' },
  { code: 'OM', name_en: 'Oman', name_kr: '오만', continent: 'Middle East' },
  { code: 'QA', name_en: 'Qatar', name_kr: '카타르', continent: 'Middle East' },
  { code: 'SA', name_en: 'Saudi Arabia', name_kr: '사우디아라비아', continent: 'Middle East' },
  { code: 'ZA', name_en: 'South Africa', name_kr: '남아프리카 공화국', continent: 'Africa' },
  { code: 'TN', name_en: 'Tunisia', name_kr: '튀니지', continent: 'Africa' },
  { code: 'AE', name_en: 'United Arab Emirates', name_kr: '아랍에미리트', continent: 'Middle East' },
];

/**
 * Get fallback countries sorted by English name
 */
export const getSortedFallbackCountries = () => {
  return [...fallbackCountries].sort((a, b) => a.name_en.localeCompare(b.name_en));
};
